module.exports = __webpack_public_path__ + "img/figure-4.1caf9d09.png";